import React from 'react'

export default function UiSharingContentBlock(props) {
    

    return (
        <>
            <div className='sb-sharing-content-block'>
                <div className='sb-sharing-content-block__content'>
                    <div className='sb-sharing-content-block__left'>
                        <h3>Share the zing with a friend</h3>
                        <span>Refer them today and start sharing the sweet rewards</span>
                    </div>
                    <div className='sb-sharing-content-block__right'>
                        <div className='sb-sharing-content-block__right-input'>
                            {props.children}
                        </div>
                        
                    </div>
                </div>
            </div>
            
        </>
    )
}
